import { graphql } from "../gql";

export const updateClaimAuditGroupMutationDoc = graphql(`
  mutation updateClaimAuditGroup($id: UUID!, $patch: ClaimAuditGroupPatch!) {
    updateClaimAuditGroup(input: { id: $id, patch: $patch }) {
      claimAuditGroup {
        id
        name
        auditType
      }
    }
  }
`);
